import { useState } from "react";

import "../styles/fullscreenbutton.css"
declare global {
  interface HTMLElement {
    msRequestFullscreen?: () => Promise<void>;
    mozRequestFullscreen?: () => Promise<void>;
    webkitRequestFullscreen?: () => Promise<void>;
    webkitEnterFullscreen?: () => Promise<void>;
  }
}
export const FullScreenButton = () => {
  const [fullScreen, setFullScreen] = useState(false);

  function openFullscreen() {
    var docElm = document.documentElement;
    if (docElm.requestFullscreen) {
      docElm.requestFullscreen();
    } else if (docElm.webkitRequestFullscreen) {
      docElm.webkitRequestFullscreen();
    } else if (docElm.mozRequestFullscreen) {
      docElm.mozRequestFullscreen();
    } else if (docElm.msRequestFullscreen) {
      docElm.msRequestFullscreen();
    } else if (docElm.webkitEnterFullscreen) {
    }
  }
  function closeFullScreen() {
    document.exitFullscreen();
  }
  document.addEventListener("fullscreenchange", (event) => {
    setFullScreen(!fullScreen);
  });

  return (
    <i
      className={
        !fullScreen
          ? "fas fa-expand-alt fullScreenButton "
          : "fas fa-compress-alt fullScreenButton"
      }
      onClick={() => {
        !fullScreen ? openFullscreen() : closeFullScreen();
      }}
    ></i>
  );
};
